import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="px-4 py-10 mt-8 border-t border-white/5" style={{background:"#050508"}}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
          <div className="col-span-2 md:col-span-1">
            <img src="/logos/logo-main.png" alt="NagNail Tickets" style={{height:"48px"}} className="mb-3"/>
            <p className="text-gray-500 text-xs leading-relaxed">Sri Lanka's #1 event ticketing platform. QR tickets via WhatsApp.</p>
          </div>
          <div>
            <p className="text-white font-semibold text-sm mb-3">Quick Links</p>
            <div className="space-y-2">
              {[["Events","/"],["My Tickets","/my-tickets"],["Organiser Login","/organiser-login"]].map(([l,t]) => (
                <Link key={t} to={t} className="block text-gray-500 hover:text-gray-300 text-xs transition">{l}</Link>
              ))}
            </div>
          </div>
          <div>
            <p className="text-white font-semibold text-sm mb-3">Legal</p>
            <div className="space-y-2">
              {[["Terms of Service","/terms"],["Privacy Policy","/privacy"],["Refund Policy","/returns"]].map(([l,t]) => (
                <Link key={t} to={t} className="block text-gray-500 hover:text-gray-300 text-xs transition">{l}</Link>
              ))}
            </div>
          </div>
          <div>
            <p className="text-white font-semibold text-sm mb-3">Contact</p>
            <div className="space-y-2">
              <a href="https://wa.me/94774651468" target="_blank" rel="noreferrer"
                className="block text-gray-500 hover:text-green-400 text-xs transition">💬 WhatsApp Us</a>
              <a href="mailto:tickets@nagnail.lk" className="block text-gray-500 hover:text-gray-300 text-xs transition">📧 tickets@nagnail.lk</a>
              <a href="https://nagnail.lk" target="_blank" rel="noreferrer"
                className="block text-gray-500 hover:text-gray-300 text-xs transition">🌐 nagnail.lk</a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">© {new Date().getFullYear()} NagNail Tickets. All rights reserved.</p>
          <p className="text-gray-600 text-xs">Made with ❤️ in Sri Lanka 🇱🇰</p>
        </div>
      </div>
    </footer>
  );
}
